import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    alias: "/dashboard",
    name: "dashboard",
    component: view("Dashboard"),
    meta: {
      pageTitle: "DASHBOARD-HEADING",
    },
  },

  {
    path: "/clients",
    name: "clients",
    component: view("clients/Index"),
    meta: {
      pageTitle: "CLIENTS-HEADING",
    },
  },

  {
    path: "/clients/:id",
    name: "client",
    component: view("clients/Client"),
    meta: {
      pageTitle: "CLIENTS-HEADING",
    },
  },

  {
    path: "/warehouses",
    name: "warehouses",
    component: view("warehouses/Index"),
    meta: {
      pageTitle: "WAREHOUSES-HEADING",
    },
  },

  {
    path: "/warehouses/:id",
    name: "warehouse",
    component: view("warehouses/Warehouse"),
    meta: {
      pageTitle: "WAREHOUSE",
      pageType: "WAREHOUSE",
      mandate: "",
    },
  },

  {
    path: "/warehouses/new",
    name: "warehouseNew",
    component: view("warehouses/Warehouse"),
    meta: {
      pageTitle: "WAREHOUSE",
    },
  },

  {
    path: "/items",
    name: "items",
    component: view("items/Index"),
    meta: {
      pageTitle: "ARTICLES-HEADING",
      pageType: 'ITEMS'
    },
  },

  {
    path: "/items/:id",
    name: "item",
    component: view("items/Item"),
    meta: {
      pageTitle: "ARTICLE-HEADING",
      pageTitleEditable: true
    },
  },
  {
    path: "/my-account",
    name: "myAccount",
    component: view("userManagement/User"),
    meta: {
      pageTitle: "MY_ACCOUNT-HEADING",
    },
  },

  {
    path: "/user-management",
    name: "userManagement",
    component: view("userManagement/Index"),
    meta: {
      pageTitle: "USER_MANAGEMENT-HEADING",
    },
  },
  {
    path: "/user-management/new",
    name: "newUser",
    component: view("userManagement/User"),
    meta: {
      pageTitle: "USER-HEADER-NEW_USER",
    },
  },
  {
    path: "/user-management/:id",
    name: "user",
    component: view("userManagement/User"),
    meta: {
      pageTitle: "USER-HEADER",
    },
  },
  {
    path: "/configuration/settings",
    name: "settings-settings",
    component: view("settings/Settings"),
    meta: {
      pageTitle: "SETTINGS-SETTINGS-HEADING",
    },
  },
  {
    path: "/configuration/bundle-groups",
    name: "settings-bundle_groups",
    component: view("settings/bundleGroups/Index"),
    meta: {
      pageTitle: "SETTINGS-BUNDLE_GROUPS-HEADING",
    },
  },
  {
    path: "/configuration/bundle-groups/:id",
    name: "settings-bundle_groups-detail",
    component: view("settings/bundleGroups/bundleGroup"),
    props: true,
    meta: {
      pageTitle: "SETTINGS-BUNDLE_GROUP-DETAIL-HEADING",
    },
  },

  {
    path: "/configuration/derivation-rules",
    name: "settings-derivation_rules",
    component: view("settings/derivationRules/Index"),
    meta: {
      pageTitle: "SETTINGS-DERIVATION_RULES-HEADING",
      pageType: 'derivation_rules'
    },
  },

  {
    path: "/configuration/derivation-rules/:id",
    name: "settings-derivation_rule-detail",
    component: view("settings/derivationRules/DerivationRule"),
    meta: {
      pageTitle: "SETTINGS-DERIVATION_RULES-DETAIL-HEADING",
    },
  },
  {
    path: "/configuration/packaging-classes",
    name: "settings-packaging_classes",
    component: view("settings/packagingClasses/Index"),
    meta: {
      pageTitle: "SETTINGS-PACKAGING_CLASSES-HEADING",
    },
  },
  {
    path: "/configuration/packaging-classes/:id",
    name: "settings-packaging_classes-detail",
    component: view("settings/packagingClasses/PackagingClass"),
    props: true,
    meta: {
      pageTitle: "SETTINGS-PACKAGING_CLASSES-DETAIL-HEADING",
    },
  },
  {
    path: "/configuration/packaging-classes/new",
    name: "settings-packaging_classes-detail-new",
    component: view("settings/packagingClasses/PackagingClass"),
    meta: {
      pageTitle: "SETTINGS-PACKAGING_CLASSES-DETAIL-HEADING-NEW",
    },
  },
  {
    path: "/configuration/production-systems",
    name: "settings-production_systems",
    component: view("settings/productionSystems/Index"),
    meta: {
      pageTitle: "SETTINGS-PRODUCTION_SYSTEMS-HEADING",
    },
  },

  {
    path: "/configuration/lhf",
    name: "settings-lhf",
    component: view("settings/lhf/Index"),
    meta: {
      pageTitle: "SETTINGS-LHF-HEADING",
    },
  },

  {
    path: "/configuration/attributes",
    name: "settings-attributes-main",
    component: view("settings/attributes/AttributesMain"),
    meta: {
      pageTitle: "SETTINGS-ATTRIBUTES-HEADING",
    },
    children: [
      {
        path: "",
        name: "settings-attributes",
        component: view("settings/attributes/Index"),
        meta: {
          pageTitle: "SETTINGS-ATTRIBUTES-HEADING",
        }
      },
      {
        path: "item/:id?",
        name: "settings-attributes-item",
        component: view("settings/attributes/Attribute"),
        meta: {
          pageTitle: "SETTINGS-ATTRIBUTES-HEADING",
        } 
      }
    ],
  },
  {
    path: "/configuration/translations",
    name: "settings-translations",
    component: view("settings/translations/Index"),
    meta: {
      pageTitle: "SETTINGS-TRANSLATIONS-HEADING",
    },
  },

  {
    path: "/configuration/help-texts",
    name: "settings-help",
    component: view("settings/help/Index"),
    meta: {
      pageTitle: "SETTINGS-HELP-TEXTS-HEADING",
    },
  },

  {
    path: "/configuration/help-texts/:id",
    name: "helpEdit",
    component: view("settings/help/Edit"),
    meta: {
      pageTitle: "SETTINGS-HELP-TEXTS-HEADING",
    },
  },
  {
    path: "/release-notes/",
    name: "releaseNotes",
    component: view("ReleaseNotes"),
    meta: {
      pageTitle: "RELEASE-NOTES",
    },
  },

  {
    path: "/reset-password/:token",
    name: "resetPassword",
    component: view("Login"),
    meta: {
      pageTitle: "Reset Password",
    },
  },

  {
    path: "/login",
    name: "login",
    component: view("Login"),
    meta: {
      pageTitle: "Login",
    },
  },

  {
    path: "/logout",
    name: "logout",
    component: view("Login"),
    meta: {
      pageTitle: "Login",
    },
  },

  {
    path: "*",
    name: "404",
    component: view("NotFoundComponent"),
    meta: {
      pageTitle: "HEADING-404",
    },
  },
];

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
// -----------------------------------------------------------------------------
function view(name) {
  return () => import("@/views/" + name + ".vue");
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
